import React from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import Card from "../components/Card";
import SplitCard from "../components/SplitCard";
import Correction from "../assets/images/correction.svg";
import ExamImage from "../assets/images/exam.svg";
import ExamImage2 from "../assets/images/exam-2.svg";
import ReportImage from "../assets/images/report.svg";
import UsersImage from "../assets/images/users.svg";
import InoivceImage from "../assets/images/invoice.svg"
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Panel() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div className={`cards-container row justify-content-center flex-fill align-items-center${user.role === 1 ? ' admin-cards-container' : ''}`}>
        {user.role == 0 && (
          <>
            <Card
              Image={ExamImage2}
              name={"آزمون های پیش رو"}
              wrapperClassName="d-lg-none"
              onClickCard={() => {
                navigate("/FutureExams");
              }}
            />
            <Card
              Image={ExamImage}
              name={"آزمون های قبلی"}
              wrapperClassName="d-lg-none"
              onClickCard={() => {
                navigate("/PastExams");
              }}
            />
            <SplitCard
              wrapperClassName="d-none d-lg-flex"
              topImage={ExamImage2}
              topName={"آزمون های پیش رو"}
              onTopClick={() => {
                navigate("/FutureExams");
              }}
              bottomImage={ExamImage}
              bottomName={"آزمون های قبلی"}
              onBottomClick={() => {
                navigate("/PastExams");
              }}
            />
            <Card
              Image={ReportImage}
              name={"کارنامه ها"}
              onClickCard={() => {
                navigate("/Results");
              }}
            />
              <Card
                  Image={ExamImage}
                  name={"فایل ها"}
                  onClickCard={() => {
                      navigate("/Files");
                  }}
              />
          </>
        )}

        {user.role == 1 && (
          <>
            {/* Exams */}
            <Card
              compact
              Image={ExamImage}
              name={"آزمون ها"}
              onClickCard={() => {
                navigate("/exams");
              }}
            />
            <Card
              compact
              Image={ExamImage2}
              name={"آزمون های پیش رو"}
              onClickCard={() => {
                navigate("/FutureExams");
              }}
            />
            <Card
              compact
              Image={ExamImage}
              name={"آزمون های قبلی"}
              onClickCard={() => {
                navigate("/PastExams");
              }}
            />
            <Card
              compact
              Image={ExamImage}
              name={"فایل ها"}
              onClickCard={() => {
                navigate("/Bundles");
              }}
            />
            <Card
              compact
              Image={ExamImage}
              name={"مشاهده فایل ها"}
              onClickCard={() => {
                navigate("/Files");
              }}
            />

            {/* Users */}
            <Card
              compact
              Image={UsersImage}
              name={"کاربران"}
              onClickCard={() => {
                navigate("/users");
              }}
            />

            {/* Finance & reports */}
            <Card
              compact
              Image={ReportImage}
              name={"کارنامه ها"}
              onClickCard={() => {
                navigate("/Products/Reports");
              }}
            />
            <Card
              compact
              Image={InoivceImage}
              name={"پرداخت ها"}
              onClickCard={() => {
                navigate("/Products/Invoices");
              }}
            />
            <Card
              compact
              Image={InoivceImage}
              name={"ثبت پرداخت دستی"}
              onClickCard={() => {
                navigate("/AddInvoice");
              }}
            />
            <Card
              compact
              Image={ExamImage2}
              name={"کد تخفیف"}
              onClickCard={() => {
                navigate("/Discounts");
              }}
            />
            <Card
              compact
              Image={ReportImage}
              name={"حذف سابقه آزمون"}
              onClickCard={() => {
                navigate("/DeleteHistory");
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default Panel;
